import React from 'react';
import PropTypes from 'prop-types';
import styles from './Dropdown.module.scss';

const DropdownItem = ({disabled, anchor, selected, children, containerRef, ...props}) => {

    const classes = [styles.itemContainer];
    if (anchor) classes.push(styles.itemAnchor);
    if (selected) classes.push(styles.itemSelected);
    if (disabled) classes.push(styles.itemDisabled);


    return (
        <div className={classes.join(' ')} ref={containerRef} {...props}>
            {children}
        </div>
    );
};

DropdownItem.propTypes = {
    containerRef: PropTypes.any,
    disabled: PropTypes.bool,
    selected: PropTypes.bool,
    anchor: PropTypes.bool
};

DropdownItem.defaultProps = {
    containerRef: React.createRef(),
    disabled: false,
    selected: false,
    anchor: false
};

export default DropdownItem;